import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createComplain } from "@/lib/api/complain.api"
import { useAuthStore } from "@/store/auth.store"

export function useCreateComplain() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: Parameters<typeof createComplain>[0]) => {
      if (!accessToken) throw new Error("Not authenticated")
      return createComplain(payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-complains"] })
      queryClient.invalidateQueries({ queryKey: ["all-complains"] })
    },
  })
}
